module.exports = __webpack_public_path__ + "img/bot-chip-warning-badge.55d0994c.svg";